module.exports = __webpack_public_path__ + "img/retrofit-2.0275da7a.png";